<template>
  <div class="find-member">
    <el-row class="team-selection">
      <el-col>
        <select
          class="tw-w-full tw-px-2 tw-text-sm tw-placeholder-gray-800 tw-text-black tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9 tw-font-normal"
          @change="handleSelectTeam($event)"
          :class="boldFont ? 'tw-font-medium' : 'tw-font-normal'"
        >
          <option disabled selected value="">Select a team</option>
          <option
            v-for="item in allTeamsFiltered"
            :key="item._id"
            :label="item.name"
            :value="item._id"
          >
            {{ `${item.name} (${item.ageLvl})` }}
          </option>
        </select>
      </el-col>
      <el-col>
        <!-- <select
          class="tw-w-full tw-px-2 tw-text-black tw-text-sm tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9"
          v-model="managementChoice"
        >
          <option selected value="Players">Players</option>
          <option value="Non-Players">Non-Players</option>
        </select> -->

        <label class="tw-font-normal tw-grid tw-grid-cols-2 tw-px-2 tw-pb-2 tw-pt-4 input">
          <div v-for="(element, index) in mgmtChoice" :key="index" class="tw-flex tw-items-center">
            <input type="radio" v-model="managementChoice" :value="element.value" />
            <span class="tw-mt-auto tw-mb-1px tw-text-sm tw-leading-3">{{ element.option }} </span>
          </div>
        </label>
      </el-col>

      <el-col>
        <select
          class="tw-w-full tw-px-2 tw-text-black tw-text-sm tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9"
          v-model="teamAgeLvl"
          v-if="managementChoice === 'Players'"
          :class="teamAgeLvl ? 'tw-font-medium' : 'tw-font-normal'"
        >
          <option selected value="">Age level</option>
          <option v-for="item in ageLevels" :key="item.name" :value="item.name">
            {{ item.name }}
          </option>
        </select>
      </el-col>
    </el-row>

    <el-row v-if="currentTeam" class="team-profile">
      <el-row class="player-management" v-if="currentTeam && managementChoice === 'Players'">
        <div class="control-panel">
          <div class="tw-flex tw-justify-center tw-text-xs">
            <input
              class="tw-hidden"
              id="currentMembers"
              type="radio"
              v-model="activeChoice"
              value="Current Members"
            />
            <label
              class="tw-h-8 tw-py-2 tw-px-3 tw-text-center tw-rounded-l-lg hover:tw-bg-green-300 hover:tw-text-black"
              :class="{
                'tw-bg-green-700 tw-text-white': activeChoice === 'Current Members',
                'tw-bg-white tw-text-gray-700 tw-border tw-border-gray-200':
                  activeChoice === 'Current Squad',
              }"
              for="currentMembers"
              >Current Members</label
            >
            <input
              class="tw-hidden"
              id="currentSquad"
              type="radio"
              v-model="activeChoice"
              value="Current Squad"
            />
            <label
              class="tw-h-8 tw-py-2 tw-px-3 tw-text-center tw-rounded-r-lg hover:tw-bg-green-300 hover:tw-text-black"
              :class="{
                'tw-bg-green-700 tw-text-white': activeChoice === 'Current Squad',
                'tw-bg-white tw-text-gray-700 tw-border tw-border-gray-200':
                  activeChoice === 'Current Members',
              }"
              for="currentSquad"
              >Current Squad</label
            >
          </div>
        </div>

        <el-row class="squad-list" v-if="activeChoice === 'Current Members'">
          <ul class="list-group list-group-flush tw-text-sm">
            <li class="list-group-item fadeIn" v-for="member in clubPlayers" :key="member._id">
              <el-row>
                <el-col :span="20">
                  <input
                    class="my-checkbox"
                    type="checkbox"
                    :value="member._id"
                    :name="member._id"
                    :id="member._id"
                    v-model="checkedClubPlayers"
                  />
                  <label :for="member._id">
                    {{ displayPreferName(member.profile) }}
                  </label>
                </el-col>
                <el-col :span="4">
                  <br />
                  <label class="text-center">
                    <i
                      class="el-icon-check custom-icon fadeIn"
                      :id="`icon_${member._id}`"
                      v-if="checkedClubPlayers.includes(member._id)"
                  /></label>
                </el-col>
              </el-row>
            </li>
          </ul>

          <button
            class="btn-success"
            type="success"
            @click="addToSquad"
            v-if="checkedClubPlayers.length > 0"
          >
            Add to Squad
          </button>
        </el-row>

        <el-row class="squad-list" v-if="activeChoice === 'Current Squad'">
          <ul class="list-group list-group-flush tw-text-sm">
            <li class="list-group-item fadeIn" v-for="member in squadPlayers" :key="member._id">
              <el-row>
                <el-col :span="20">
                  <input
                    class="my-checkbox"
                    type="checkbox"
                    :value="member._id"
                    :name="member._id"
                    :id="member._id"
                    v-model="checkedSquadPlayers"
                  />
                  <label :for="member._id">
                     {{ displayPreferName(member.profile) }}
                  </label
                  >
                </el-col>
                <el-col :span="4">
                  <br />
                  <label class="text-center">
                    <i
                      class="el-icon-check custom-icon fadeIn"
                      :id="`icon_${member._id}`"
                      v-if="checkedSquadPlayers.includes(member._id)"
                  /></label>
                </el-col>
              </el-row>
            </li>
          </ul>

          <button
            type="success"
            class="btn-success"
            @click="removeFromSquad"
            v-if="checkedSquadPlayers.length > 0"
          >
            Remove from Squad
          </button>
        </el-row>
      </el-row>
    </el-row>

    <el-row class="np-management" v-if="currentTeam && managementChoice === 'Non-Players'">
      <el-row class="role-filter">
        <el-col>
          <select
            class="tw-w-full tw-px-2 tw-text-black tw-text-sm tw-placeholder-gray-800 tw-bg-transparent tw-border-b-2 tw-border-gray-200 tw-appearance-none tw-h-9"
            v-model="roleFilter"
            @change="filterNPByRole"
            :class="roleFilter ? 'tw-font-medium' : 'tw-font-normal'"
          >
            <option :value="null" selected>Role</option>
            <option
              v-for="item in nonPlayerRoles"
              :key="item.name"
              :label="item.name"
              :value="item.type"
            >
              {{ item.name }}
            </option>
          </select>
        </el-col>
      </el-row>

      <div class="control-panel tw--mt-5px">
        <div class="tw-flex tw-justify-center tw-text-xs">
          <input
            class="tw-hidden"
            id="currentMembers"
            type="radio"
            v-model="activeNPChoice"
            value="Current Members"
          />
          <label
            class="tw-h-8 tw-py-2 tw-px-3 tw-text-center tw-rounded-l-lg hover:tw-bg-green-300 hover:tw-text-black"
            :class="{
              'tw-bg-green-700 tw-text-white': activeNPChoice === 'Current Members',
              'tw-bg-white tw-text-gray-700 tw-border tw-border-gray-200':
                activeNPChoice === 'Current Squad',
            }"
            for="currentMembers"
            >Current Members</label
          >
          <input
            class="tw-hidden"
            id="currentSquad"
            type="radio"
            v-model="activeNPChoice"
            value="Current Squad"
          />
          <label
            class="tw-h-8 tw-py-2 tw-px-3 tw-text-center tw-rounded-r-lg hover:tw-bg-green-300 hover:tw-text-black"
            :class="{
              'tw-bg-green-700 tw-text-white': activeNPChoice === 'Current Squad',
              'tw-bg-white tw-text-gray-700 tw-border tw-border-gray-200':
                activeNPChoice === 'Current Members',
            }"
            for="currentSquad"
            >Current Squad</label
          >
        </div>
      </div>

      <el-row class="squad-list" v-if="activeNPChoice === 'Current Members'">
        <ul class="list-group list-group-flush tw-text-sm">
          <li class="list-group-item fadeIn" v-for="member in clubNonPlayers" :key="member._id">
            <el-row>
              <el-col :span="20">
                <input
                  class="my-checkbox"
                  type="checkbox"
                  :value="member._id"
                  :name="member._id"
                  :id="member._id"
                  v-model="checkedClubNPlayers"
                />
                <label :for="member._id">
                  {{ displayPreferName(member.profile) }}
                </label
                >
              </el-col>
              <el-col :span="4">
                <br />
                <label>
                  <i
                    class="el-icon-check fadeIn"
                    :id="`icon_${member._id}`"
                    v-if="checkedClubNPlayers.includes(member._id)"
                /></label>
              </el-col>
            </el-row>
          </li>
        </ul>

        <button
          type="success"
          class="btn-success"
          @click="addToSquad"
          v-if="checkedClubNPlayers.length > 0"
        >
          Add to Squad
        </button>
      </el-row>

      <el-row class="squad-list" v-if="activeNPChoice === 'Current Squad'">
        <ul class="list-group list-group-flush tw-text-sm">
          <li
            class="list-group-item fadeIn"
            v-for="member in updatedSquadNPlayers"
            :key="member._id"
          >
            <el-row>
              <el-col :span="20">
                <input
                  class="my-checkbox"
                  type="checkbox"
                  :value="member._id"
                  :name="member._id"
                  :id="member._id"
                  v-model="checkedSquadNPlayers"
                />
                <label :for="member._id">
                  {{ displayPreferName(member.profile) }}
                </label>
              </el-col>
              <el-col :span="4">
                <br />
                <label>
                  <i
                    class="el-icon-check fadeIn"
                    :id="`icon_${member._id}`"
                    v-if="checkedSquadNPlayers.includes(member._id)"
                /></label>
              </el-col>
            </el-row>
          </li>
        </ul>

        <button
          type="success"
          class="btn-success"
          @click="removeFromSquad"
          v-if="checkedSquadNPlayers.length > 0"
        >
          Remove from Squad
        </button>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import _ from "lodash";
import dayjs from "@/utils/dayjs";
import {
  orgtree,
  errormsg,
  ageLevels,
  memberTypes,
  nonPlayerRoles,
  roles,
  currentSeason,
} from "../../utils/constants";
import { calculateAge } from "../../utils/utilities";
doRoleFilter;

const formatWithName = (pl) => {
  const preferFirstName = pl.profile.preferNameStatus
    ? (pl.profile.preferFirstName || pl.profile.firstName)
    : pl.profile.firstName;
  const preferLastName = pl.profile.preferNameStatus
    ? (pl.profile.preferLastName || pl.profile.lastName)
    : pl.profile.lastName;

  const name = `${preferFirstName} ${preferLastName}`;
  return {
    ...pl,
    name,
  };
};
const doTypeFilter = (type, player, entityId) =>
  player.assignedBySuper
    ? true
    : player.activeRegos.find((r) => r.memberType === type && r.entityId === entityId);
const doNameFilter = (name, player) =>
  name ? player.name.toLowerCase().includes(name.toLowerCase()) : true;
const doRoleFilter = (role, player, entityId) => {
  if (role) {
    const rol = nonPlayerRoles.find((r) => r.type === role.toLowerCase());

    const rl = rol.memberType;
    return (
      player.activeRegos.filter((r) => r.memberType === rl.toLowerCase() && r.entityId === entityId)
        .length > 0 ||
      player.activeRegos.filter(
        (r) => r.permit === true && r.type === rl.toLowerCase() && r.entityId === entityId
      ).length > 0
    );
  }
  return true;
};
const doGenderFilter = (gender, player) => (gender ? player.profile.gender === gender : true);
const doAgeFilter = (level, player) => {
  if (level && level !== "") {
    const age = calculateAge(player.profile.dob, true);
    const { dispensations } = player;

    let rule;
    for (const i of ageLevels) {
      if (i.name === level) rule = i;
    }

    if (!rule) return false;

    const { min, max } = rule;
    const ageInBracket = level.includes("Under") ? age === max : age > min;
    if (ageInBracket) return true;
    if (dispensations && dispensations.length > 0) {
      return dispensations
        .map((d) => {
          if (d.dispensated === true && (d.rule.includes("above") || d.rule.includes("below"))) {
            const thisrule = d.rule;
            const number = parseInt(thisrule.split("(")[1].split(")")[0]);
            const add = thisrule.split(" ").pop() === "above";
            const modifiedAge = add ? age + number : age - number;
            return modifiedAge >= min && modifiedAge <= max;
          }
          return false;
        })
        .some((r) => r === true);
    }
  }
  return false;
};

export default {
  name: "SquadManagement",
  data() {
    return {
      mgmtChoice: [
        { option: "Players Only", value: "Players" },
        { option: "Non-Players Only", value: "Non-Players" },
      ],
      roles,
      orgtree,
      errormsg,
      ageLevels,
      ageLevelsTest: [
        "Under 4",
        "Under 5",
        "Under 6",
        "Under 7",
        "Under 8",
        "Under 9",
        "Under 10",
        "Under 11",
        "Under 12",
        "Under 13",
        "Under 14",
        "Under 15",
        "Under 16",
        "Under 17",
        "Under 18",
        "Seniors",
        "Masters",
        "All Ages",
      ],
      currentTeam: { _id: null, ageLvl: "" },
      loading: true,
      nameFilter: "",
      genderFilter: "",
      roleFilter: null,
      teamAgeLvl: "",
      squadAllocation: {
        availablePlayers: [],
        availableNonPlayers: [],
        players: [],
        nonplayers: [],
      },
      checkedClubPlayers: [],
      checkedClubNPlayers: [],
      checkedSquadPlayers: [],
      checkedSquadNPlayers: [],
      managementChoice: "Players",
      activeChoice: "Current Members",
      activeNPChoice: "Current Members",
      searchTeam: null,
      allTeams: [],
      filters: [
        {
          value: "",
          prop: "name",
        },
        {
          value: [],
        },
      ],
      pageSize: 25,
      tableProps: {
        border: true,
      },
      paginationProps: {
        pageSizes: [25, 50, 100],
      },
      memberTypes,
      nonPlayerRoles,
      boldFont: false,
      updatedSquadNPlayers: [],
    };
  },
  mounted() {
    this.$http
      .get(`/nrl/api/v1/admin/teams?season=${currentSeason}`)
      .then((response) => {
        this.allTeams = response.data.data;
        this.loading = false;
      })
      .catch(() => {
        this.$customError();
        this.loading = false;
      });
  },
  methods: {
    filterNPByRole() {
      const np = this.availableNPlayersFiltered.filter((p) =>
        this.squadAllocation.nonplayers.includes(p._id)
      );

      if (typeof this.roleFilter !== "string") {
        this.updatedSquadNPlayers = np;
      } else {
        this.updatedSquadNPlayers = np.filter(
          (n) => n.nonplayerTeams[0].squadRole === this.roleFilter
        );
      }

      this.updatedSquadNPlayers = _.sortBy(this.updatedSquadNPlayers, [
        "profile.firstName",
        "profile.lastName",
      ]);
    },
    changeTeam() {
      this.checkedClubPlayers = [];
      this.checkedClubNPlayers = [];
      this.checkedSquadPlayers = [];
      this.checkedSquadNPlayers = [];
    },
    clearFilters() {
      this.nameFilter = "";
      this.genderFilter = "";
      this.roleFilter = "";
    },
    modifiedFormatter(row) {
      return row.modifiedAt ? dayjs(row.modifiedAt).format("MMMM Do YYYY, h:mm:ss a") : "NA";
    },
    handleSelectTeam($event) {
      const id = $event.target.value;

      if (!id) return;
      this.boldFont = true;

      this.changeTeam();
      this.$store.commit("root/loading", true);
      this.currentTeam = this.allTeams.find((team) => team._id === +id);

      this.teamAgeLvl = this.currentTeam && this.currentTeam.ageLvl;

      Promise.all([
        this.$http.get(`/nrl/api/v1/admin/squad/players/${id}`),
        this.$http.get(`/nrl/api/v1/admin/squad/nonplayers/${id}`),
      ])
        .then(([playerRes, nonPlayerRes]) => {
          const playersData = playerRes.data.data;
          const nonPlayersData = nonPlayerRes.data.data;
          const allPlayers = [...playersData.clubplayers, ...playersData.players];
          const allNonPlayers = [...nonPlayersData.clubnonplayers, ...nonPlayersData.nonplayers];
          const availablePlayers =
            allPlayers.length > 0 ? allPlayers.map((p) => formatWithName(p)) : [];
          const availableNonPlayers = allNonPlayers.length
            ? allNonPlayers.map((p) => formatWithName(p))
            : [];

          const players =
            playersData.players.length > 0 ? playersData.players.map((p) => p._id) : [];

          const nonplayers =
            nonPlayersData.nonplayers.length > 0 ? nonPlayersData.nonplayers.map((p) => p._id) : [];

          this.squadAllocation = {
            availablePlayers,
            availableNonPlayers,
            players,
            nonplayers,
          };
          this.$store.commit("root/loading", false);
        })
        .catch(() => {
          this.$customError();
          this.$store.commit("root/loading", false);
        });
    },
    addToSquad() {
      this.$store.commit("root/loading", true);
      const { checkedClubPlayers, checkedClubNPlayers } = this;
      const { players, nonplayers } = this.squadAllocation;
      const { _id: teamid } = this.currentTeam;

      Promise.all([
        this.$http.put(`/nrl/api/v1/admin/squad/${teamid}`, {
          players: players.concat(checkedClubPlayers),
          type: "player",
        }),
        this.$http.put(`/nrl/api/v1/admin/squad/${teamid}`, {
          nonplayers: nonplayers.concat(checkedClubNPlayers),
          type: "nonplayer",
        }),
      ])
        .then(([playerResponse, nonPlayerRes]) => {
          if (playerResponse.data.message) {
            this.checkedClubPlayers = [];
            this.$store.commit("root/loading", false);
            return this.$customError(playerResponse.data.message);
          }
          if (nonPlayerRes.data.message) {
            this.$store.commit("root/loading", false);
            this.checkedClubNPlayers = [];
            return this.$customError(nonPlayerRes.data.message);
          }
          if (!playerResponse.data.message && !nonPlayerRes.data.message) {
            this.$customSuccess();
          }

          // Remove player assigned by super admin
          this.squadAllocation.players = this.squadAllocation.players.concat(checkedClubPlayers);
          this.squadAllocation.nonplayers =
            this.squadAllocation.nonplayers.concat(checkedClubNPlayers);
          this.checkedClubPlayers = [];
          this.checkedClubNPlayers = [];
          this.squadAllocation.availablePlayers = _.filter(
            this.squadAllocation.availablePlayers,
            (ap) =>
              !(ap.assignedBySuper === true && !_.includes(this.squadAllocation.players, ap._id))
          );
          // update role for the non-player
          checkedClubNPlayers.forEach((cnp) => {
            this.$http.put(`/nrl/api/v1/admin/members/nonplayerteams/${cnp}/${teamid}`, {
              squadRole: this.roleFilter,
            });
          });
          this.$store.commit("root/loading", false);
        })
        .catch((error) => {
          this.$store.commit("root/loading", false);
          this.$customError(_.get(error, "response.data.message"));
        });
    },
    removeFromSquad() {
      this.$store.commit("root/loading", true);
      const { checkedSquadPlayers, checkedSquadNPlayers } = this;
      const { players, nonplayers } = this.squadAllocation;
      const { _id: teamid } = this.currentTeam;
      Promise.all([
        this.$http.put(`/nrl/api/v1/admin/squad/${teamid}`, {
          players: players.filter((p) => !checkedSquadPlayers.includes(p)),
          type: "player",
        }),
        this.$http.put(`/nrl/api/v1/admin/squad/${teamid}`, {
          nonplayers: nonplayers.filter((p) => !checkedSquadNPlayers.includes(p)),
          type: "nonplayer",
        }),
      ])
        .then(([playerResponse, nonPlayerRes]) => {
          if (playerResponse.data.message) {
            this.$customError(playerResponse.data.message);
          }
          if (nonPlayerRes.data.message) {
            this.$customError(nonPlayerRes.data.message);
          }
          if (!playerResponse.data.message && !nonPlayerRes.data.message) {
            this.$customSuccess();
          }

          this.squadAllocation.players = this.squadAllocation.players.filter(
            (p) => !checkedSquadPlayers.includes(p)
          );
          this.squadAllocation.nonplayers = this.squadAllocation.nonplayers.filter(
            (p) => !checkedSquadNPlayers.includes(p)
          );
          this.checkedSquadPlayers = [];
          this.checkedSquadNPlayers = [];
          // Remove player assigned by super admin
          this.squadAllocation.availablePlayers = _.filter(
            this.squadAllocation.availablePlayers,
            (ap) =>
              !(ap.assignedBySuper === true && !_.includes(this.squadAllocation.players, ap._id))
          );
          this.$store.commit("root/loading", false);
        })
        .catch(() => {
          this.$store.commit("root/loading", false);
          this.$customError();
        });
    },
    displayPreferName(profile){
      const preferFirstName = profile.preferNameStatus
    ? ( profile.preferFirstName || profile.firstName)
    : profile.firstName;
  const preferLastName = profile.preferNameStatus
    ? ( profile.preferLastName || profile.lastName)
    : profile.lastName;

     return `${preferFirstName} ${preferLastName}`;
    },
  },
  computed: {
    ageFilter: {
      get() {
        return this.teamAgeLvl;
      },
      set(val) {
        this.teamAgeLvl = val;
      },
    },
    teamMemberType() {
      const type = memberTypes.find((m) => m.type === this.currentTeam.memberType);
      return type ? type.name : null;
    },
    // nonPlayerRoles() {
    //   return this.nonPlayerRoles.map((p) => p.name);
    //   // return this.memberTypes.filter((p) => p.playing === false).map((p) => p.name);
    // },
    allTeamsFiltered() {
      if (this.allTeams) {
        if (this.searchTeam) {
          return this.allTeams.filter((team) =>
            team.name.toLowerCase().includes(this.searchTeam.toLowerCase())
          );
        }
        return this.allTeams;
      }
      return [];
    },
    clubPlayers() {
      return _.sortBy(
        this.availablePlayersFiltered.filter((p) => !this.squadAllocation.players.includes(p._id)),
        ["profile.firstName", "profile.lastName"]
      );
    },
    squadPlayers() {
      return _.sortBy(
        this.availablePlayersFiltered.filter((p) => this.squadAllocation.players.includes(p._id)),
        ["profile.firstName", "profile.lastName"]
      );
    },
    clubNonPlayers() {
      return _.sortBy(
        this.availableNPlayersFiltered.filter(
          (p) => !this.squadAllocation.nonplayers.includes(p._id)
        ),
        ["profile.firstName", "profile.lastName"]
      );
    },
    squadNPlayers: {
      get() {
        this.updatedSquadNPlayers = _.sortBy(
          this.availableNPlayersFiltered.filter((p) =>
            this.squadAllocation.nonplayers.includes(p._id)
          ),
          ["profile.firstName", "profile.lastName"]
        );
        return this.updatedSquadNPlayers;
      },
      set(val) {
        if (this.roleFilter !== undefined) {
          const np = this.availableNPlayersFiltered.filter((p) =>
            this.squadAllocation.nonplayers.includes(p._id)
          );

          this.updatedSquadNPlayers = np.filter((n) => {
            return n.nonplayerTeams[0].squadRole === this.roleFilter;
          });

          this.updatedSquadNPlayers = _.sortBy(this.updatedSquadNPlayers, [
            "profile.firstName",
            "profile.lastName",
          ]);
          return this.updatedSquadNPlayers;
        } else {
          this.updatedSquadNPlayers = _.sortBy(
            this.availableNPlayersFiltered.filter((p) =>
              this.squadAllocation.nonplayers.includes(p._id)
            ),
            ["profile.firstName", "profile.lastName"]
          );
          return this.updatedSquadNPlayers;
        }
      },
    },
    availablePlayersFiltered() {
      let filteredAvailableP = [];
      if (this.currentTeam.orgtree && this.currentTeam.orgtree.club) {
        const { _id } = this.currentTeam.orgtree.club;
        const { availablePlayers, players } = this.squadAllocation;
        const { nameFilter, ageFilter, genderFilter } = this;
        filteredAvailableP = availablePlayers.filter((player) => {
          if (players.includes(player._id)) {
            return doAgeFilter(ageFilter, player);
          }
          return (
            doGenderFilter(genderFilter, player) &&
            doAgeFilter(ageFilter, player) &&
            doNameFilter(nameFilter, player) &&
            doTypeFilter(this.currentTeam.memberType, player, _id)
          );
        });
      }
      return filteredAvailableP;
    },
    availableNPlayersFiltered() {
      let filteredAvailableNP = [];
      if (this.currentTeam.orgtree && this.currentTeam.orgtree.club) {
        const { _id } = this.currentTeam.orgtree.club;
        const { availableNonPlayers, nonplayers } = this.squadAllocation;
        const { nameFilter, roleFilter } = this;
        filteredAvailableNP = availableNonPlayers.filter((player) => {
          if (nonplayers.includes(player._id)) return true;
          return doRoleFilter(roleFilter, player, _id) && doNameFilter(nameFilter, player);
        });

        this.updatedSquadNPlayers = _.sortBy(
          filteredAvailableNP.filter((p) => this.squadAllocation.nonplayers.includes(p._id)),
          ["profile.firstName", "profile.lastName"]
        );
      }
      return filteredAvailableNP;
    },
    clearance() {
      return this.$store.getters["user/activeRole"].type;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .control-panel {
  padding-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 2rem;
  .el-radio-button__inner {
    width: 9rem;
  }
}

.el-col .el-col-24 {
  margin: 5px 0px;
}

.custom-icon {
  font-weight: bold;
  font-size: 1.25rem;
}

select {
  appearance: none; /* Remove default arrow */
  background-image: url("../../assets/chevron_down.svg"); /* Add custom arrow */
  background-position: center right;
  background-repeat: no-repeat;
  background-size: 40px 40px;
  background-position-y: 8px;
}

.team-profile {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  .management-switch {
    margin-top: 0.5rem;
  }
  .team-name {
    margin-top: 2rem;
    letter-spacing: 0.09rem;
  }
}

.player-management {
  width: 100%;
}

.np-management {
  .role-filter {
    display: flex;
    justify-content: center;
  }
}

.team-selection {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.squad-list {
  display: flex;
  flex-direction: column;
  width: 100%;
  .list-group {
    padding-inline-start: 0;
    .list-group-item {
      list-style-type: none;
      border-bottom: 1px solid #ddd;
      input {
        display: none;
      }

      label {
        padding: 1rem;
        width: 100%;
      }

      .el-row {
        display: flex;
        align-items: center;
        .el-col {
          display: flex;
        }
      }
    }
  }
}

.btn-success {
  @apply tw-justify-center tw-w-full  tw-mt-4 tw-h-10 tw-rounded-lg tw-text-sm tw-not-italic tw-font-medium tw-leading-11px tw-tracking-normal tw-text-center  tw-text-white  tw-bg-green-700  tw-mb-4 hover:tw-bg-green-300 hover:tw-text-black sm:tw-w-64;
}

.squad-player-list {
  font-size: 0.98rem;
  margin: 0;
  padding-bottom: 2rem;
  border-radius: 6px;
  border: 0px solid #000000;

  li {
    list-style-type: none;
    transition: background-color 200ms, color 200ms, border 200ms, transform 1.5s 0s,
      opacity 1.25s 0s;
    transform: translateX(0);
    background: white;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    color: #000;
  }

  ul {
    padding-top: 2rem;
    margin-top: -1.5rem;
  }

  input {
    opacity: 0;
  }
  label {
    display: block;
    width: 100%;
    height: 100%;
  }

  .to-squad {
    border-left: 2px solid #000 !important;
  }

  .from-squad {
    border-left: 2px solid #000 !important;
  }

  .submitSquadChange {
    display: block;
    margin-top: 2rem;
    width: 100%;
    background: #000 !important;
  }

  .icon-remove-from-squad,
  .icon-add-to-squad {
    color: #000 !important;
  }

  .noshow {
    opacity: 0;
  }

  .show {
    opacity: 1;
  }

  .is-empty {
    text-align: center;
    margin-top: 7rem;
    padding: 2rem;
    color: #000;
    font-family: "ProximaNova-Regular";
  }
}
</style>
